import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'

import { connect } from 'react-redux'
import { csvFileSelect } from '../../actions/'

import Button from '@material-ui/core/Button'

import DescriptionIcon from '@material-ui/icons/Description'
import BrowserStore from 'store'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200
  },

  chip: {
    margin: theme.spacing(0.5)
  }
}))

class UploadForm extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { data } = this.props

    return (
      <React.Fragment>
        <TableContainer component={Paper}>
          <Table style={{ overflowX: 'auto' }} aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell>User ID</TableCell>

                <TableCell>Integration Id</TableCell>
                <TableCell align='right'>Login Id</TableCell>
                <TableCell align='right'>First Name</TableCell>
                <TableCell align='right'>Last Name</TableCell>
                <TableCell align='right'>Sortable Name</TableCell>
                <TableCell align='right'>Short Name</TableCell>
                <TableCell align='right'>Email</TableCell>
                <TableCell align='right'>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.csvData.map((row, i) => (
                <TableRow key={`tt-${i}`}>
                  <TableCell align='right'>{row[0]}</TableCell>
                  <TableCell align='right'>{row[1]}</TableCell>
                  <TableCell align='right'>{row[2]}</TableCell>
                  <TableCell align='right'>{row[3]}</TableCell>
                  <TableCell align='right'>{row[4]}</TableCell>
                  <TableCell align='right'>{row[5]}</TableCell>
                  <TableCell align='right'>{row[6]}</TableCell>
                  <TableCell align='right'>{row[7]}</TableCell>
                  <TableCell align='right'>{row[8]}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  data: state.CreateUsers
})
const mapDispatchToProps = (dispatch) => ({
  onFileSelect: (file) => {
    dispatch(csvFileSelect(file))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadForm)
